import { Flex } from 'components/base/layout-components';
import styled from 'styled-components';

export const StyledGraphHeader = styled(Flex)`
  ${({ subtitle }) => (subtitle ? `width: calc(100% - 4rem);` : `width: 100%;`)}
`;
